import { Components, Theme } from "@mui/material";
export const muiSliderTheme = (
  theme: Theme,
): Pick<Components<Omit<Theme, "components">>, "MuiSlider"> => ({
  MuiSlider: {
    styleOverrides: {
      root: {
        "& .MuiSlider-thumb": {
          width: "16px",
          height: "16px",
          [theme.breakpoints.down(1280)]: {
            width: "12px",
            height: "12px",
          },
        },
      },
    },
  },
});
